export const GTM_ID = process.env.NEXT_PUBLIC_GTM_ID || '';

// Only load GTM in production builds that have a container ID, so local
// development and preview deployments don't send data to Google. The tags
// themselves (such as GA4) are configured in the GTM container.
export const GTM_ENABLED =
  process.env.NODE_ENV === 'production' && GTM_ID !== '';

// https://developers.google.com/tag-platform/security/guides/consent
// Everything starts as denied (see google-tag.tsx). Rejecting keeps it that
// way: Google tags then don't set cookies and only send cookieless pings.
export const updateConsent = (granted: boolean) => {
  if (window && window.gtag) {
    const value = granted ? 'granted' : 'denied';
    window.gtag('consent', 'update', {
      ad_storage: value,
      ad_user_data: value,
      ad_personalization: value,
      analytics_storage: value,
    });
  }
};
